export { default as HashratesWidget } from './components/HashratesWidget';
export { default as HashratesChart } from './components/HashratesChart';
